import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../services';

/**
 * Route guard that redirects authenticated users away from public routes.
 *
 * If the user is already authenticated, navigation is redirected to
 * the dashboard while preserving query parameters.
 * Unauthenticated users are allowed to proceed.
 *
 * If chat=true query param is present, redirects to the chatbot page.
 *
 * @returns `true` when navigation is allowed, or a `UrlTree` redirecting
 * to the dashboard for authenticated users.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const HomeRedirectGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
) => {
  const router = inject(Router);
  const isAuthenticated = inject(AuthService).isAuthenticated;
  const { queryParams, fragment } = route;

  // If chat=true, allow navigation to proceed (app component handles chat widget mode)
  if (queryParams['chat'] === 'true') {
    return true;
  }

  // If `/#confirm-registration` allow navigation to proceed
  if (fragment === 'confirm-registration') {
    console.log('fragmenttt', fragment);
    return true;
  }

  if (isAuthenticated()) {
    return router.parseUrl('/dashboard');
  }

  return true;
};
